import React from 'react'
import UniLogo from "assets/AboutUniprest/wpLogo.png"
import './WpMenuItems.scss'
import { useWpMenuContext } from 'contexts/WpMenuContext'
import MyLink from 'components/MyLink'

// Import custom components and hooks using index files
import { DesktopMenu, MobileMenu } from './components'
import { useResponsive, useMobileMenu } from './hooks'

const WpMenuItems = ({ isScrolled }) => {
  // Get menu items from the context
  const { menuItems } = useWpMenuContext();

  const headerMenu = menuItems?.headerMenu
  
  // Check if screen is mobile
  const isMobile = useResponsive(922);
  
  // Mobile menu state and handlers
  const { isMobileMenuOpen, toggleMobileMenu, closeMobileMenu } = useMobileMenu();

  return (
    <div className={`wp-menu-container ${isScrolled ? 'scrolled' : ''}`}>
      <MyLink className="logo-column" to={process.env?.REACT_APP_WORDPRESS_URL}>
        <img src={UniLogo} alt="Uniprest Logo" className="wp-logo" />
      </MyLink>
      
      {isMobile ? (
        <>
          <button
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className="hamburger-icon"></span>
          </button>
          
          <MobileMenu 
            isOpen={isMobileMenuOpen} 
            onClose={closeMobileMenu} 
            menuItems={headerMenu} 
          />
        </>
      ) : (
        <DesktopMenu menuItems={headerMenu} />
      )}
    </div>
  );
};

export default WpMenuItems
